/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentVisualDeck {
    constructor(cscom) {
        if (!(this instanceof CurrentVisualDeck)) {
            return new CurrentVisualDeck(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/visual-deck/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/visual-deck/list', null, data);
    }

}
